var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCertificateOperation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7407 21.3851C22.5661 21.2365 22.2919 21.25 22.1282 21.4153L18.2536 25.3289C18.0899 25.4942 18.0988 25.7487 18.2734 25.8973C18.448 26.0459 18.7223 26.0324 18.8859 25.867L22.7605 21.9535C22.9242 21.7882 22.9153 21.5337 22.7407 21.3851Z",
    fill: "#0C1C33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6214 23.0895C15.4577 23.2548 15.4666 23.5093 15.6412 23.6579L18.273 25.8978C18.4476 26.0464 18.7218 26.0328 18.8855 25.8675C19.0491 25.7022 19.0403 25.4477 18.8657 25.2991L16.2339 23.0592C16.0593 22.9106 15.785 22.9242 15.6214 23.0895Z",
    fill: "#0C1C33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1903 29.5901C22.475 29.5901 25.1378 26.9273 25.1378 23.6426C25.1378 20.3579 22.475 17.6952 19.1903 17.6952C15.9056 17.6952 13.2429 20.3579 13.2429 23.6426C13.2429 26.9273 15.9056 29.5901 19.1903 29.5901ZM19.1903 30.2636C22.847 30.2636 25.8113 27.2993 25.8113 23.6426C25.8113 19.9859 22.847 17.0216 19.1903 17.0216C15.5337 17.0216 12.5693 19.9859 12.5693 23.6426C12.5693 27.2993 15.5337 30.2636 19.1903 30.2636Z",
    fill: "#0C1C33",
    stroke: "#0C1C33",
    strokeWidth: 0.383
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2678 0.322327H10.0242L9.84249 0.484683L0.432718 8.89343L0.219727 9.08376V9.3694V26.7875V27.4259H0.85806H13.7561C13.4798 27.0298 13.2457 26.602 13.0604 26.1492H1.49639V9.65505L10.5115 1.59899H20.2404V17.1044C20.6821 17.1748 21.1091 17.2888 21.5171 17.442V0.96066V0.322327H20.8788H10.2678Z",
    fill: "#0C1C33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89648 12.1749H15.3249",
    stroke: "#0C1C33",
    strokeWidth: 1.27667,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89648 15.5733H15.3249",
    stroke: "#0C1C33",
    strokeWidth: 1.27667,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCertificateOperation);
export default __webpack_public_path__ + "static/media/ic-certificate-operation.9945fefa7b1f546e10eabe2f589f7b4a.svg";
export { ForwardRef as ReactComponent };